import { PAYPAL_THEME } from '@paypalcorp/pp-react'

export const mainBrandPrimaryBlueText = 'sysColorPrimaryMain'
export const mainBrandPrimaryBlueColor = PAYPAL_THEME[mainBrandPrimaryBlueText]

export const contrastBrandWPrimaryWhiteText = 'sysColorPrimaryContrast'
export const contrastBrandWPrimaryWhiteColor =
  PAYPAL_THEME[contrastBrandWPrimaryWhiteText]

export const mainBrandSecondaryBlueText = 'sysColorSecondaryMain'
export const mainBrandSecondaryBlueColor =
  PAYPAL_THEME[mainBrandSecondaryBlueText]

export const mainBaseBackgroundText = 'sysColorBackgroundMain'
export const mainBaseBackgroundColor = PAYPAL_THEME[mainBaseBackgroundText]

export const mainBrandTertiaryText = 'sysColorTertiaryMainHover'
export const mainBrandTertiaryColor = PAYPAL_THEME[mainBrandTertiaryText]

export const sysColorBackgroundMediumContrast =
  'sysColorBackgroundMediumContrast'
export const lightGrayColor = PAYPAL_THEME[sysColorBackgroundMediumContrast]

export const sysColorBackgroundSurface = 'sysColorBackgroundSurface'
export const whiteColor = PAYPAL_THEME[sysColorBackgroundSurface]
